// extracted by mini-css-extract-plugin
module.exports = {"countdown":"style_countdown__24cjQ","danger":"style_danger__3QoWQ"};